// extracted by mini-css-extract-plugin
export var avatarContainer = "_r-0";
export var avatarTypingWave = "_r-i";
export var gray = "_r-f";
export var green = "_r-c";
export var icon = "_r-9";
export var image = "_r-1";
export var lg = "_r-6";
export var md = "_r-5";
export var presenceDot = "_r-b";
export var red = "_r-d";
export var sm = "_r-4";
export var status = "_r-a";
export var typingDot = "_r-h";
export var typingPill = "_r-g";
export var xl = "_r-7";
export var xs = "_r-3";
export var xxl = "_r-8";
export var xxs = "_r-2";
export var yellow = "_r-e";